import {useListView} from '../../core/TemplosListViewProvider'
import {TemplosListGrouping} from './TemplosListGrouping'
import {GenericListSearchComponent} from './GenericListSearchComponent'
import {TemplosListToolbar} from './TemplosListToolbar'
import {KTIcon} from '../../../../../../../_metronic/helpers'

type Props = {
  termo: string
  add_path: string
  filtersVisible?: boolean
  onToggleFilters?: () => void
}

const TemplosListHeader: React.FC<Props> = ({termo, add_path, filtersVisible, onToggleFilters}) => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <div className='d-flex align-items-center gap-3'>
        <GenericListSearchComponent termo={termo} />
        {onToggleFilters && (
          <button
            type='button'
            className='btn btn-light-primary btn-sm fw-bold'
            onClick={onToggleFilters}
            title={filtersVisible ? 'Esconder filtros' : 'Mostrar filtros'}
          >
            <KTIcon iconName='filter' className='fs-2' />
            Filtros
            <KTIcon iconName={filtersVisible ? 'arrow-up' : 'arrow-down'} className='fs-2' />
          </button>
        )}
      </div>
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <TemplosListGrouping /> : <TemplosListToolbar add_path={add_path} />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {TemplosListHeader}
